interface Props {
  href?: string;
}
const TikTokEmbed = ({ href }: Props) => {
  const id = href?.match(/\/([0-9]{6,})/);
  if (!id) return null;
  return (
    <span className="tw-relative tw-flex tw-justify-center tw-inline-block">
      <iframe
        src={`https://www.tiktok.com/embed/${id[1]}`}
        scrolling="no"
        allow="encrypted-media"
        className="tw-min-w-[325px] tw-max-w-[625px] tw-aspect-[325/739]"
      ></iframe>
    </span>
  );
};

export default TikTokEmbed;
